import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/membershipLengthSagas";

const AgreementStatusFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector(
    (state) => state.membershipLengthByAgreement.filters.agreement_statuses
  );
  const selectedOption = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.agreement_status
  );

  return (
    <div className="select-box" style={{ width: "190px" }}>
      <p>Agreement Status</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        includeFilter={false}
        onSelectChange={(data) =>
          dispatch(actionCreators.updateFilters({ agreement_status: data }))
        }
      />
    </div>
  );
};

export default AgreementStatusFilter;
